import { transform, type TransformedCartData } from "../transformers/CartResponseTransformer";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import type { CartResponseDTO } from "../dto/CartResponseDTO";
import { resolveActiveCartResourceId } from "../utils/cartResourceIdentity";

interface CartViewCall {
  activeCartId: string;
}

export async function getData(activeCartId: string): Promise<TransformedCartData> {
  if (!activeCartId) {
    throw new Error("Cannot load cart data without an explicit Active Cart identity");
  }
  const response = await scheduleCall("cartView", { activeCartId });
  const dto: CartResponseDTO = await response.json();
  return transform(dto);
}

export async function getActiveCartData(): Promise<TransformedCartData | null> {
  const activeCartId = await resolveActiveCartResourceId();
  return activeCartId ? getData(activeCartId) : null;
}

export function emptyCartData(): TransformedCartData {
  return {
    accountNumber: "",
    comment: "",
    dstError: false,
    entryGroups: [],
    entryGroupsByNumber: {},
    packageEntries: [],
    packageEntriesById: {},
    productCodes: [],
    products: [],
  };
}

registerCallProcessor<CartViewCall>({
  type: "cartView",
  execute: async ({ activeCartId }) => {
    return occFetch(occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/data`));
  },
  canBeExecuted: (ongoingCalls) => {
    const isDeleteOngoing = ongoingCalls.some((call) => call.type === "delete" || call.type === "deleteCart");
    return !isDeleteOngoing;
  },
});
